import { api, withFallback } from "./api";
import { FAQ_GROUPS } from "../data/faqs";

export const faqService = {
  list: () => withFallback(() => api.get("/faqs"), FAQ_GROUPS),
};
